<template>
  <page>
    <search-bar :on-top="ui.onTop" @go-search="goSearch" />
    <div ref="searchBarObserved" class="search-bar-observed"></div>
    <cms ref="cms" />
    <feed-goods v-if="renderFeedGood" :tabs="tabs" />
  </page>
</template>

<script>
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import { APP_CONFIG } from '@/defines/environment/config'
import SearchBar from './components/search_bar'
import cms from './components/cms'
import FeedGoods from './components/feed_goods/index'
export default {
  name: 'PageCategoryArea',
  components: {
    cms,
    FeedGoods,
    SearchBar
  },
  beforeRouteEnter(to, from, next) {
    const category = to.params.category
    switch (category) {
      case 'frozen':
        navBar.setTitle({
          text: '冻品专区'
        })
        break
      default:
        navBar.setTitle({
          text: APP_CONFIG.app_name
        })
    }
    const cmsPageId = to.query.cms_page_id
    next(vm => {
      vm.fetchCMSContent(cmsPageId)
      // vm.$nativeNav.changeType(1)
    })
  },
  onLogin() {
    window.location.reload()
  },
  data() {
    return {
      tabs: {},
      cmsContent: {},
      ui: {
        onTop: true
      },
      renderFeedGood: false
    }
  },
  mounted() {
    this.observeSearchBar()
  },
  methods: {
    observeSearchBar() {
      const target = this.$refs.searchBarObserved
      const observer = new IntersectionObserver(
        entries => {
          if (entries && entries[0]) {
            this.ui.onTop = entries[0].isIntersecting
          }
        },
        {
          threshold: [0, 1]
        }
      )
      observer.observe(target)
    },
    async fetchCMSContent(cmsPageId) {
      try {
        if (cmsPageId) {
          const res = await API.cms.getById({
            pageid: Number(cmsPageId)
          })
          // eslint-disable-next-line camelcase
          const modules = res?.page_data ?? []
          this.tabs =
            modules.find(module => module.code === 'image_text_anchor') || {}
          this.renderFeedGood = true
          this.$refs.cms.render(res)
        }
      } catch (error) {
        console.log(error)
      }
    },
    goSearch() {
      this.$track(this.$trackMap.categoryArea.goSearch)
      this.$nativeRedirect(this.$nativeRoutes.search)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar-observed {
  position: absolute;
  top: 0;
  right: 0;

  width: 1px;
  height: 44px;
}
</style>
